import { Component, Input, OnInit } from '@angular/core';
import {CommonModule} from '@angular/common';
import {Aangifte, BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";


@Component({
    selector: 'snelstart-venture-fiscaal-feature-tekst-pga-scholing',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './tekst-pga-scholing.component.html',
    styleUrl: './tekst-pga-scholing.component.scss',
})
export class TekstPgaScholingComponent implements OnInit {

    @Input() public id!: string;
    public ibAangifte = {} as Aangifte;
    public focusedElementId: string | null = null;
    public year = 2024;
    public actualYear: number = new Date().getFullYear();

    public bedragMbo = 0
    public bedragHbo = 0;
    public bedragMboMaand = 0
    public bedragHboMaand = 0;


    constructor(
        public dataService: BokkzIbDataService) {
    }

    ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((value) => {
            if (value.year !== undefined) {
                this.year = value.year;
            }
            if (this.year == 2024) {
                this.bedragMbo = 1693
                this.bedragHbo = 2443;
                this.bedragMboMaand = 141.09;
                this.bedragHboMaand = 203.59;
            }
            if (this.year == 2025) {
                this.bedragMbo = 1693
                this.bedragHbo = 2443;
                this.bedragMboMaand = 141.09;
                this.bedragHboMaand = 203.59;
            }
        })
    }

}
